/**
 * @description
 * SpinnerComponent displays a centered, backdrop-blurred global loading overlay.
 * Automatically responds to reactive state changes from SpinnerService.
 *
 * Dependencies:
 * - SpinnerService (Loading state and message observable)
 */

import { Component, ElementRef, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SpinnerService } from '../spinner.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, MatProgressSpinnerModule]
})
export class SpinnerComponent {
  public spin = inject(SpinnerService);

  // Le voile monte dans le TOP LAYER dès que le @if le crée : depuis Angular 22 le CDK pose ses
  // dialogues en `popover` (top layer), qu'aucun z-index du document ne peut recouvrir.
  @ViewChild('voile') set voile(ref: ElementRef<HTMLElement> | undefined) {
    const el = ref?.nativeElement;
    if (!el || typeof el.showPopover !== 'function' || el.matches(':popover-open')) return;
    try { el.showPopover(); } catch (e) { console.warn('[SpinnerComponent] showPopover refusé', e); }
  }
}
